import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import animations from './animations';
import NavItem from "../NavItem";
import Logo from '../Logo';
import { agentLogout } from '../../utils/agentUtil';

class NavDesktop extends Component {

    constructor(props) {
        super(props);

        const isAgent = localStorage.getItem('isAgent') === 'true';
        const agentPortalUsername = localStorage.getItem('agentUsername') || '';

        this.state = {
            mainNavItems: [],
            isAgent: isAgent,
            agentPortalUsername: agentPortalUsername,
        };
    }

    componentDidMount() {
        this.setState({
            mainNavItems: this.props.mainItems
        });

        this.updateAgentStatus()
    }

    componentDidUpdate(prevProps) {
        if (prevProps !== this.props) {
            this.setState({
                mainNavItems: this.props.mainItems
            });
        }
        animations.didUpdate(this);
    
        this.updateAgentStatus()
    }

    updateAgentStatus () {
        const isAgent = localStorage.getItem('isAgent') === 'true';
        const agentPortalUsername = localStorage.getItem('agentUsername') || '';
    
        if (this.state.isAgent !== isAgent || this.state.agentPortalUsername !== agentPortalUsername) {
            this.setState({
                isAgent: isAgent,
                agentPortalUsername: agentPortalUsername
            });
        }
    }

    handleAgentLogout () {
        agentLogout()
        this.setState({
            isAgent: false,
            agentPortalUsername: ''
        });
    }

    handleMouseEnter(event) {
        animations.handleMouseEnter(event, this);
    }

    resetNavigation() {
        animations.resetNavigation(this);
    }

    isSmb() {
        return window.location.pathname.includes('small-business');
    }

    render() {
        const MainNav = Object.keys(this.state.mainNavItems).map(key => {
            let item = this.state.mainNavItems[key];
            return (
                <NavItem
                    key={key}
                    title={item.title}
                    url={item.url}
                    children={item.children}
                    active={item.active}
                    handleMouseEnter={animations.handleSubNavMouseEnter}
                    handleMouseLeave={animations.handleSubNavMouseLeave}
                />
            );
        });

        return (
            <section className="navigation" onMouseEnter={this.handleMouseEnter.bind(this)}>
                <div className="nav-bg" />
                <div className="mainmenu">
                    <Logo />
                    <nav>
                        <ul>
                            {MainNav}
                        </ul>
                    </nav>
                </div>
                <div className="submenu">
                    <div className="subnav-bg" />
                    <div className="subnav-bg-animated" />
                    {this.state.isAgent ? 
                        <button className="btn agent-btn" onClick={() => this.handleAgentLogout()}>
                            Not {this.state.agentPortalUsername}? Log Out
                        </button>
                    :
                        <ul>
                            <li className="submenu-item">
                                <span className="phone">{this.isSmb() ? '1300 211 211' : '1300 393 835'}</span>
                            </li>
                            <li className="submenu-item">
                                <Link to="/contact" className="hover-left">Contact Us</Link>
                            </li>
                            <li className="submenu-item">
                                <Link to="/login" className="hover-left">Login</Link>
                            </li>
                        </ul>
                    }
                </div>
            </section>
        );
    };

}

export default NavDesktop;


// WEBPACK FOOTER //
// ./resources/assets/js/layout/NavDesktop/NavDesktop.js